import { useEffect, useState } from 'react';
import styled from "@emotion/styled";
import { colors as themeColors } from 'src/theme';
import { Flex, InputLabel } from 'src/components';
import { ValidationErrorStyle } from "src/common";

const Container = styled.div((props: { colors: { background?: string, text?: string, backgroundSelected?: string, textSelected?: string } }) => ({
  borderRadius: '12px',
  padding: '4px',
  backgroundColor: props.colors.background,
}));

const OptionContainer = styled(Flex)({
  position: 'relative'
});

const Option = styled.div((props: { isSelected: boolean, colors: { background?: string, text?: string, backgroundSelected?: string, textSelected?: string } }) => ({
  color: props.isSelected ? props.colors.textSelected : props.colors.text,
  cursor: 'pointer',
  textAlign: 'center' as const,
  padding: '8px 16px',
  flex: 1,
  zIndex: 1,
  fontSize: '16px',
  fontWeight: props.isSelected ? '700' : '400',
  lineHeight: '20px'
}));

const Glider = styled.div((props: { position: number, count: number, colors: { background?: string, text?: string, backgroundSelected?: string, textSelected?: string } }) => ({
  position: 'absolute' as const,
  top: 0,
  bottom: 0,
  left: 0,
  backgroundColor: props.colors.backgroundSelected,
  width: `${100 / props.count}%`,
  height: '100%',
  zIndex: 0,
  transition: 'transform 0.3s ease',
  borderRadius: '8px',
  transform: `translateX(${props.position * 100}%)`
}));

const InputLabelStyle = styled(InputLabel)({
  marginBottom: '8px',
});

interface SwitchProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  className?: string;
  label?: string;
  error?: string;
  colors?: {
    background?: string;
    text?: string;
    backgroundSelected?: string;
    textSelected?: string;
  }
}

export const Switch: React.FC<SwitchProps> = ({ value = false, onChange, className, label, error, colors: customColors = {} }) => {
  const colors = {
    background: themeColors.background6,
    text: themeColors.text2,
    backgroundSelected: themeColors.primary1,
    textSelected: themeColors.text7,
    ...customColors
  };
  const [selected, setSelected] = useState<boolean>(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleChange = (newValue: boolean) => {
    setSelected(newValue);
    if (onChange) onChange(newValue);
  };

  const options = [
    { value: true, label: 'Da' },
    { value: false, label: 'Ne' }
  ];

  const selectedIndex = options.findIndex(option => option.value === selected);

  return (
    <>
      {label ? <InputLabelStyle>{label}</InputLabelStyle> : null}
      <Container className={className} colors={colors}>
        <OptionContainer>
          {options.map((option) => (
            <Option
              key={String(option.value)}
              onClick={() => handleChange(option.value)}
              isSelected={selected === option.value}
              colors={colors}
            >
              {option.label}
            </Option>
          ))}
          <Glider position={selectedIndex} count={options.length} colors={colors} />
        </OptionContainer>
      </Container>
      {error ? <ValidationErrorStyle>{error}</ValidationErrorStyle> : null}
    </>
  );
};